import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTooltip } from "./useTooltip";
import { getTooltipStyles } from "./Tooltip.styles";
import type { TooltipProviderProps } from "./Tooltip.types";
import { cn } from "@/utils/cn";

export const TooltipProvider = ({ children }: TooltipProviderProps) => {
  const { isVisible, content, position, coords } = useTooltip();
  const styles = getTooltipStyles({ position });

  // Estado para garantir que o 'document.body' esteja disponível (seguro para SSR)
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const renderTooltip = () => {
    if (!isMounted || !isVisible || !coords || !content) {
      return null;
    }

    return createPortal(
      <div
        className={cn(styles.wrapper, isVisible ? "opacity-100" : "opacity-0")}
        style={{
          top: coords.top,
          left: coords.left,
        }}
        role="tooltip"
      >
        {content}
      </div>,
      document.body
    );
  };

  return (
    <>
      {children}
      {renderTooltip()}
    </>
  );
};
